var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backGround"},[_vm._m(0),_c('ShadowInfo')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logoClass"},[_c('img',{staticStyle:{"height":"100%","border-radius":"10px"},attrs:{"src":"logo.jpg"}})])
}]

export { render, staticRenderFns }